export function getTemplateDefinition(slideTemplate,image,body){
	const hasImage=image===''? false:true
	let templateDefinition='BodyLeft'
	if(slideTemplate==='standard'){
		if(hasImage){
			templateDefinition='BodyLeftImageRight'
		} else templateDefinition='BodyLeft'
	}
	else if(slideTemplate==='right'){
		templateDefinition='BodyRightImageLeft'
	}
	else if(slideTemplate==='center'){
		if(hasImage){
			templateDefinition='BodyCenterImageCenter'
		}else{
			templateDefinition='BodyCenter'
		}
	}
	return templateDefinition
}



// WEBPACK FOOTER //
// ./src/utils/slides/getTemplateDefinition.js